import { GridColDef } from '@mui/x-data-grid';
import { FilterDefinition } from '@lambda-layer/models/FilterDefinition/FilterDefinition.ts';
import { FilterSelections } from '@lambda-layer/types/filter.ts';

export const applyDefaultFilterOperators = (
  columnDefinitions: GridColDef[]
) => {
  return columnDefinitions.map(c => {
    return { ...c, filterable: false };
  });
};

/**
 * Return filter selections in the order they're defined in the filter definitions.
 *
 * @param filterDefinitions filter definitions
 * @param filterSelections user filter selections
 */
export const orderFilterSelections = (
  filterDefinitions: FilterDefinition[],
  filterSelections: FilterSelections
) => {
  return filterDefinitions.reduce((acc, filterDefinition) => {
    const filterSelectionMatch = filterSelections[filterDefinition.id];
    if (filterSelectionMatch) {
      acc[filterDefinition.id] = filterSelectionMatch;
    }
    return acc;
  }, {} as FilterSelections);
};
